import { z } from 'zod';
const AccessControlSchema = z.object({
    entries: z.array(z.object({
        type: z.enum(['user', 'org', 'team']),
        id: z.string(),
        permissions: z.array(z.enum(['read', 'write'])),
    })),
});
export const ExperienceProductLineSchema = z.enum(['insights', 'customer_success']);
export const ExperienceOverridesSchema = z
    .object({
    insights: z
        .record(z.string().max(35), z.record(z.string().max(150), z.string().trim().min(1).max(4000)))
        .optional(),
    customer_success: z
        .record(z.string().max(35), z.record(z.string().max(150), z.string().trim().min(1).max(4000)))
        .optional(),
})
    .strict();
export const ExperienceProfileInputSchema = z
    .object({
    name: z.string().trim().min(1).max(150),
    description: z.string().trim().max(1000).default(''),
    overrides: ExperienceOverridesSchema.default({}),
})
    .strict();
export const ExperienceProfileUpdateSchema = ExperienceProfileInputSchema.extend({
    expectedRevision: z.number().int().positive(),
});
export const ExperienceProfileSchema = ExperienceProfileInputSchema.extend({
    accessControl: AccessControlSchema,
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    revision: z.number().int().positive(),
    status: z.enum(['active', 'archived']),
    clonedFromId: z.string().uuid().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const ExperienceProfileListSchema = z.object({
    items: z.array(ExperienceProfileSchema),
    page: z.object({ limit: z.number(), offset: z.number(), total: z.number() }),
});
export const ExperienceDefaultsSchema = z
    .object({
    insights: z.string().uuid().nullable(),
    customer_success: z.string().uuid().nullable(),
})
    .strict();
//# sourceMappingURL=index.js.map